import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('policy-status-icon', []);

interface PolicyStatusIconController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    size: string;
}

const statusClass = {
    active: 'active',
    pending_active: 'pending-active',
    pending_terminate: 'cancellation-pending',
    terminated: 'cancelled',
    expired: 'expired'
};

type CombinedPolicyStatus = PolicyStatus | 'pending_terminate';

module.component('policyStatusIcon', {
    template: template,
    bindings: {
        policyInfo: '<',
        size: '@?'
    },
    controller: function(this: PolicyStatusIconController, $element: angular.IAugmentedJQuery) {
        this.$onInit = () => {
            let policyStatus: CombinedPolicyStatus = this.policyInfo.status;

            if (policyStatus !== 'terminated' && policyStatus !== 'expired' && this.policyInfo.pending_terminate) {
                policyStatus = 'pending_terminate';
            }

            if (this.policyInfo) {
                $element.addClass(statusClass[policyStatus]);
            }

            if (this.size) {
                $element.addClass(this.size);
            }
        };
    }
});

export { module };
